import React, { useEffect, useState } from "react";
import { Form } from "react-bootstrap";
import axios from "axios";
import { toast } from "react-toastify";
import {
  MDBSelect,
  MDBCard,
  MDBCardBody,
  MDBCardTitle,
  MDBValidation,
  MDBCardImage,
  MDBTextArea,
  MDBBtn,
  MDBInput,
  MDBBadge,
  div,
  MDBInputGroup,
} from "mdb-react-ui-kit";
import dummyFingerprint from "../assets/images/dummyFingerPrint.jpg";
import dummyProfileImage from "../assets/images/dummyPhoto.png";
import dummySignature from "../assets/images/dummySignature.png";
import "../styles/fees.css";
import formatDate from "../utilities/dateFormat";
import fingerPrintServices from "../utilities/demo";
import Test from "./Test";
import CameraPopup from "../components/CameraPopup";
import { clearImageData } from "../redux-toolkit/slices/imageSlice";
import { useDispatch, useSelector } from "react-redux";
import Loader from "../components/Loader";
import convertToUnderscoreFormat from "../utilities/convertToUnderscoreFormat";
import validateTemplateBase64Data from "../utilities/validateTemplateBase64Data";
import ScannerLoader from "../components/ScannerLoader";
import API_BASE_URL from "../utilities/apiConfig";
import REPORT_BASE_URL from "../utilities/reportConfig";
import axiosInstance from "../utilities/apiConfig";
const Voting = () => {
  const [id, setId] = useState(0);
  const [barId, setbarId] = useState("");
  const [template1, setTemplate1] = useState("");
  const [template2, setTemplate2] = useState("");
  const [loading, setLoading] = useState(false);
  const [secugenLic, setSecugenLic] = useState("");
  const [quality, setQuality] = useState(100);
  const [showCameraPopup, setShowCameraPopup] = useState(false);
  const [profileImage, setProfileImage] = useState(dummyProfileImage);
  const [signatureImage, setSignatureImage] = useState(dummySignature);
  const [imageSrc1, setImageSrc1] = useState(dummyFingerprint);
  const [refresh, setRefresh] = useState(0);
  const [imageSrc2, setImageSrc2] = useState(dummyFingerprint);
  const [fingerPrintDB, setFingerPrintDB] = useState(false);
  const [fingerPrintVoting, setFingerPrintVoting] = useState(false);
  const [fingerPrintScanMessage, setFingerPrintScanMessage] = useState(true);
  const [isVotingSlipPrintable, setIsVotingSlipPrintable] = useState(false);
  const [isFingerPrintScannerinProgress, setIsFingerPrintScannerinProgress] =
    useState(false);
  const token = useSelector((state) => state.auth.token);
  const eligibleUserDetails = {
    advocateAlternateBarId: null,
    advocateBarId: null,
    barAssociationId: null,
    dateOfBirth: null,
    eligibilityId: null,
    fingerprintImage: null,
    isFeesPaid: false,
    isVerificationCompleted: false,
    localAddress: null,
    mobileno: null,
    name: null,
    permanentAddress: null,
    photo: null,
    relationshipType: null,
    relativeName: null,
    signature: null,
    status: null,
    verificationDate: null,
  };
  const initalFeesFormData = {
    advocateBarId: "",
    membershipTypeId: "",
    feesAmount: "",
  };
  const intitalVotingFormData = {
    advocateBarId: "",
    userId: "",
  };
  const [feesFormData, setFeesFormData] = useState(initalFeesFormData);
  const [eligibleMemberDetails, setEligibleMemberDetails] =
    useState(eligibleUserDetails);
  const [votingCompletionForm, setVotingCompletionForm] = useState(
    intitalVotingFormData
  );
  const fingerPrintService = fingerPrintServices();
  const dispatch = useDispatch();
  const baseURL = axiosInstance.defaults.baseURL;
  const [isPrintSlip, setIsPrintSlip] = useState(false);

  const handleVerifyFingerPrint = async (fingerprint2) => {
    try {
      setLoading(true);
      console.log("finger print data from fees page ", fingerPrintVoting);
      console.log("finger print data from db", fingerPrintDB);

      // Validation checks
      const data1Validation = validateTemplateBase64Data(fingerPrintDB);
      const data2Validation = validateTemplateBase64Data(fingerprint2);

      if (data2Validation && data1Validation) {
        const response = await fingerPrintService.matchFingerPrint(
          fingerPrintDB,
          fingerprint2,
          fingerPrintService.succMatch,
          fingerPrintService.failureFunc
        );
        console.log("Response of Matching:", response);

        if (response.matched) {
          toast.success("Fingerprint verified");
          dispatch(clearImageData());
          setFingerPrintScanMessage(false); // Reset the message here for successful fingerprint

          try {
            debugger;
            setLoading(true);
            const response = await axiosInstance.post(
              `/Voting/voting_completion_details_by_advocate_bar_id`,
              votingCompletionForm,
              {
                headers: {
                  "Content-Type": "application/problem+json; charset=utf-8",
                  Authorization: `Bearer ${token}`, // Include the token in the request header
                },
              }
            );
            debugger;
            console.log("handle genrate voting slip response", response.data);
            if (response.data.statusCode === 200) {
              toast.success(response.data.status);
              setIsVotingSlipPrintable(true);
              const reportUrl = `${REPORT_BASE_URL}/VotingSlip.aspx?id=${votingCompletionForm.advocateBarId}`;
              window.open(reportUrl, "_blank");
            } else {
              toast.error(response.data.status);
            }
          } catch (error) {
            if (error.response) {
              console.error("Response data:", error.response.data);
              console.error("Response status:", error.response.status);
              console.error("Response headers:", error.response.headers);
              toast.error("An unexpected error occurred. Please try again.");
            } else if (error.request) {
              console.error("Request data:", error.request);
              toast.error("No response received from the server.");
            } else {
              console.error("Error message:", error.message);
              toast.error("An error occurred.");
            }
          } finally {
            setLoading(false);
          }
        } else {
          toast.error("Fingerprint does not match");
          setFingerPrintScanMessage(true);
        }
      } else {
        toast.warning("Please scan your fingerprint.");
      }
    } catch (error) {
      console.error("Error:", error);
      toast.error("Error: Fingerprint not verified. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    debugger;
    console.log(
      "fingerPrintScanMessage after setting to false:",
      fingerPrintScanMessage
    );
  }, [fingerPrintScanMessage]); // The dependency array
  const imageData = useSelector((state) => state.profileimage?.imageData);
  const userDeatils = useSelector((state) => state.auth?.userData?.authUser);

  console.log("image data of fees page", imageData);

  const handleInputFieldChange = (e) => {
    const { name, value } = e.target;
    setEligibleMemberDetails({
      ...eligibleMemberDetails,
      [name]: value,
    });
    setFeesFormData({
      ...feesFormData,
      [name]: value,
    });
    setVotingCompletionForm({
      ...votingCompletionForm,
      advocateBarId: e.target.value,
    });
    setIsPrintSlip(false);
    console.log("Handle Input Field Change", "=>", name, " : ", value);
  };

  const handleGetEligibleAdvocateDetails = async () => {
    //debugger;
    try {
      setLoading(true);
      setFingerPrintScanMessage(true);
      setIsVotingSlipPrintable(false);
      debugger;
      if (barId !== null) {
        const formatted_bar_id = convertToUnderscoreFormat(
          votingCompletionForm.advocateBarId
        );

        console.log(formatted_bar_id);
        const response = await axiosInstance.get(
          `/Voting/get_voting_details_by_advocate_bar_id/${formatted_bar_id}`
        );
        console.log("Verifiaction data for Bar Id", response.data);
        setEligibleMemberDetails(response.data.eligibleMemberDetails);
        console.log(response.data.eligibleMemberDetails?.advocateBarId);
        setFeesFormData({
          ...feesFormData,
          advocateBarId: response.data.eligibleMemberDetails?.advocateBarId,
        });
        console.log(response.data.eligibleMemberDetails?.fingerprintData);
        setFingerPrintDB(response.data.eligibleMemberDetails?.fingerprint);

        setProfileImage(
          response.data.eligibleMemberDetails?.photo || dummyProfileImage
        );
        setSignatureImage(
          response.data.eligibleMemberDetails?.signature || dummySignature
        );
        setImageSrc2(
          response.data.eligibleMemberDetails?.fingerprintImage ||
            dummyFingerprint
        );

        if (response.data.response.statusCode === 200) {
          toast.success(response.data.response.status);

          // Fetch and set profile image
          axiosInstance
            .get(
              `/Verification/${response.data?.eligibleMemberDetails?.photo}`,
              {
                responseType: "blob", // Ensures we get binary data for the image
              }
            )
            .then((imageResponse) => {
              const imageUrl = URL.createObjectURL(imageResponse.data);
              setProfileImage(imageUrl || dummyProfileImage); // Set profile image or fallback to dummy
            })
            .catch((error) => {
              console.error("Error fetching profile image:", error);
              setProfileImage(dummyProfileImage); // Fallback to dummy image on error
            });

          // Fetch and set signature image
          axiosInstance
            .get(
              `/Verification/${response.data?.eligibleMemberDetails?.signature}`,
              {
                responseType: "blob",
              }
            )
            .then((imageResponse) => {
              const imageUrl = URL.createObjectURL(imageResponse.data);
              setSignatureImage(imageUrl || dummyProfileImage);
            })
            .catch((error) => {
              console.error("Error fetching signature image:", error);
              setSignatureImage(dummyProfileImage);
            });

          // Fetch and set fingerprint image
          axiosInstance
            .get(
              `/Verification/${response.data?.eligibleMemberDetails?.fingerprintImage}`,
              {
                responseType: "blob",
              }
            )
            .then((imageResponse) => {
              const imageUrl = URL.createObjectURL(imageResponse.data);
              setImageSrc2(imageUrl || dummyProfileImage);
            })
            .catch((error) => {
              console.error("Error fetching fingerprint image:", error);
              setImageSrc2(dummyProfileImage);
            });
        } else if (response.data.response.statusCode === 204) {
          debugger;
          setIsPrintSlip(true);
          toast.info(response.data.response.status);
          setIsVotingSlipPrintable(true);
          // const reportUrl = `${REPORT_BASE_URL}/VotingSlip.aspx?id=${votingCompletionForm.advocateBarId}`;
          // window.open(reportUrl, "_blank");
        } else {
          toast.error(response.data.response.status);
        }
      }
    } catch (error) {
      console.error("Error:", error);
    } finally {
      setLoading(false);
    }
  };

  const successFunc2 = (result) => {
    setIsFingerPrintScannerinProgress(false);
    if (result.ErrorCode === 0) {
      if (result != null && result.BMPBase64.length > 0) {
        setTemplate2(result.TemplateBase64);
        setFingerPrintVoting(result.TemplateBase64);
        setImageSrc2("data:image/bmp;base64," + result.BMPBase64);
        handleVerifyFingerPrint(result.TemplateBase64);
      }
    } else {
      if (result.ErrorCode === 3) {
        toast.error("Please check your fingerprint device");
      } else if (result.ErrorCode === 54) {
        toast.error("Timeout, scan your finger again");
      } else {
        toast.error("Please scan your finger again");
      }
      console.log("Finger print error in fee page ", result);
      // alert(`Fingerprint Capture Error Code: ${result.ErrorCode}.\nDescription: ${errorCodeToString(result.ErrorCode)}.`);
    }
  };

  const errorFunc = (status) => {
    setIsFingerPrintScannerinProgress(false);
    toast.error("Please Check Secugen fingerprit service is working properly");
    // alert(`Check if SGIBIOSRV is running; status = ${status}:`);
  };

  const callSGIFPGetData = (successCall, failCall) => {
    setIsFingerPrintScannerinProgress(true);
    const uri = "https://localhost:8000/SGIFPCapture";
    const params = `Timeout=10000&Quality=50&licstr=${encodeURIComponent(
      secugenLic
    )}&templateFormat=ISO`;

    fetch(uri, {
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
      body: params,
    })
      .then((response) => {
        if (response.ok) {
          return response.json();
        } else {
          throw new Error("Network response was not ok.");
        }
      })
      .then((data) => {
        successCall(data);
      })
      .catch((error) => {
        failCall(error);
      });
  };

  const matchScore = (succFunction, failFunction) => {
    if (template1 === "" || template2 === "") {
      alert("Please scan two fingers to verify!!");
      return;
    }
    const uri = "https://localhost:8000/SGIMatchScore";

    const params = `template1=${encodeURIComponent(
      template1
    )}&template2=${encodeURIComponent(template2)}&licstr=${encodeURIComponent(
      secugenLic
    )}&templateFormat=ISO`;

    fetch(uri, {
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
      body: params,
    })
      .then((response) => {
        if (response.ok) {
          return response.json();
        } else {
          throw new Error("Network response was not ok.");
        }
      })
      .then((data) => {
        succFunction(data);
      })
      .catch((error) => {
        failFunction(error);
      });
  };

  const succMatch = (result) => {
    const idQuality = quality;
    if (result.ErrorCode === 0) {
      if (result.MatchingScore >= idQuality) {
        toast.success(`FingerPrint Matched Successfully`);
        //alert(`MATCHED ! (${result.MatchingScore})`);
      } else {
        toast.error("Not Matched Try Again");
        //alert(`NOT MATCHED ! (${result.MatchingScore})`);
      }
    } else {
      toast.error("Error Scanning Fingerprint");
      //alert(`Error Scanning Fingerprint ErrorCode = ${result.ErrorCode}`);
    }
  };

  const failureFunc = (error) => {
    alert("On Match Process, failure has been called");
  };

  const errorCodeToString = (ErrorCode) => {
    // Implement the ErrorCodeToString function here
  };

  useEffect(() => {
    setVotingCompletionForm({
      ...votingCompletionForm,
      userId: userDeatils?.userId,
    });
    console.log("User Id From Login Session", votingCompletionForm.userId);
  }, [loading]);

  useEffect(() => {
    console.log("Advocate Bar Id", votingCompletionForm.advocateBarId);
  }, [votingCompletionForm.advocateBarId]);

  const handlePrintSlip = () => {
    const reportUrl = `${REPORT_BASE_URL}/VotingSlip.aspx?id=${votingCompletionForm.advocateBarId}`;
    window.open(reportUrl, "_blank");
  };
  return (
    <>
      {loading && <Loader />}
      {isFingerPrintScannerinProgress && <ScannerLoader />}
      <div className="row mt-5 p-3 justify-content-center">
        <h3 className="text-center mb-5 ">
          <b>Demonstration of Voting</b>
        </h3>
        <div className="row mb-5 justify-content-center">
          <div
            feedback="Please Enter Bar Id."
            invalid
            className="col-md-3 mb-1 d-flex justify-content-end"
          >
            <MDBInput
              required
              value={votingCompletionForm.advocateBarId}
              onChange={(e) => {
                handleInputFieldChange(e);
              }}
              label="Enter Bar Id"
              type="text"
              name="barId"
              className="m-0"
              id="barId"
            />
          </div>
          <div className="col-md-2 mb-1">
            <MDBBtn
              onClick={() => {
                handleGetEligibleAdvocateDetails();
              }}
            >
              Submit
            </MDBBtn>
            {isPrintSlip && (
              <>
                <MDBBtn
                  className="ms-2"
                  onClick={() => {
                    handlePrintSlip();
                  }}
                >
                  Print Slip
                </MDBBtn>
              </>
            )}
          </div>
        </div>

        {eligibleMemberDetails?.status === "Active" && (
          <>
            <div className="row justify-content-center">
              <div className="col-xxl-8 ">
                <div className="row justify-content-start mb-3">
                  <div className="col-sm-6 col-md-4  col-xl-3 mt-auto">
                    <MDBInput
                      label="Name"
                      id="name"
                      name="name"
                      value={eligibleMemberDetails?.name}
                      type="text"
                    />
                  </div>

                  <div className="col-sm-6 col-md-4  col-xl-3 mt-auto">
                    <div className="input-group">
                      <select
                        className="form-select form-select-sm py-0"
                        style={{
                          height: "calc(1.5em + 0.75rem + 2px)",
                          width: "35%",
                        }}
                        value={eligibleMemberDetails?.relationshipType}
                        name="relationshipType"
                        id="relationshipType"
                      >
                        <option value="Son">S/O</option>
                        <option value="Daughter">D/O</option>
                        <option value="Wife">W/O</option>
                      </select>

                      <div
                        className="input-group-append"
                        style={{ width: "65%" }}
                      >
                        <MDBInput
                          label="Relative Name"
                          id="relativeName"
                          name="relativeName"
                          value={eligibleMemberDetails?.relativeName}
                          type="text"
                        />
                      </div>
                    </div>
                  </div>

                  {/*<div className="col-sm-6 col-md-4  col-xl-3 mt-auto">
                                <MDBInput label='Date of Birth' id='dateOfBirth' name='dateOfBirth' value={eligibleMemberDetails?.dateOfBirth} type='date' />
                            </div> */}
                  <div className="col-sm-6 col-md-4  col-xl-3 mt-auto">
                    <MDBInput
                      label="Phone No"
                      id="mobileNo"
                      name="mobileNo"
                      value={eligibleMemberDetails?.mobileno}
                      type="text"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="row justify-content-center mb-2">
              <div className="col-xxl-8">
                <div data-mdb-input-init className="form-outline">
                  <label className="form-label" htmlFor="textAreaExample3">
                    Permanent Address
                  </label>
                  <MDBTextArea
                    className="form-control"
                    id="permanentAddress"
                    name="permanentAddress"
                    value={eligibleMemberDetails?.permanentAddress}
                    rows="2"
                  ></MDBTextArea>
                </div>
              </div>
            </div>

            <div className="row justify-content-center mb-2">
              <div className="col-xxl-8">
                {fingerPrintScanMessage ? (
                  <div className="text-danger">
                    Please verify your fingerprint before voting slip genration
                  </div>
                ) : (
                  <div className="text-success">
                    Your fingerprint is verified Please proceede for voting{" "}
                  </div>
                )}
              </div>
            </div>

            <div className="row justify-content-center my-2">
              <div className="col-xxl-8">
                <div className="row">
                  <div className="col-xl-2 col-md-3 col-sm-4">
                    <MDBCard>
                      <MDBCardBody>
                        <MDBBtn>+</MDBBtn>
                      </MDBCardBody>
                      <div class="square-aspect-ratio-container">
                        <img
                          src={profileImage}
                          className="rounded-circle mb-1 img-fluid"
                          alt="Avatar"
                        />
                      </div>
                      <MDBCardBody className="m-0 p-0">
                        <MDBCardTitle className="text-center p-0 my-2">
                          Photo
                        </MDBCardTitle>
                      </MDBCardBody>
                    </MDBCard>
                  </div>
                  <div className="col-xl-2 col-md-3 col-sm-4">
                    <MDBCard>
                      <MDBCardBody>
                        <MDBBtn
                          onClick={() =>
                            callSGIFPGetData(successFunc2, errorFunc)
                          }
                        >
                          +
                        </MDBBtn>
                      </MDBCardBody>
                      <div class="square-aspect-ratio-container">
                        <img
                          src={imageSrc2}
                          className="rounded-circle mb-1 img-fluid"
                          alt="Avatar"
                        />
                      </div>
                      <MDBCardBody className="m-0 p-0">
                        <MDBCardTitle className="text-center p-0 my-2">
                          Fingerprint
                        </MDBCardTitle>
                      </MDBCardBody>
                    </MDBCard>
                  </div>
                  <div className="col-xl-2 col-md-3 col-sm-4">
                    <MDBCard>
                      <MDBCardBody>
                        <MDBBtn>+</MDBBtn>
                      </MDBCardBody>
                      <div class="square-aspect-ratio-container">
                        <img
                          src={signatureImage}
                          className="rounded-circle mb-1 img-fluid"
                          alt="Avatar"
                        />
                      </div>

                      <MDBCardBody className="m-0 p-0">
                        <MDBCardTitle className="text-center p-0 my-2">
                          Signature
                        </MDBCardTitle>
                      </MDBCardBody>
                    </MDBCard>
                  </div>
                </div>
              </div>
            </div>

            {/* <div className="row justify-content-center my-5">
              {isVotingSlipPrintable ? (
                <div className="col-md-3 mb-1">
                  <MDBBtn>
                    <a
                      href={`${REPORT_BASE_URL}/VotingSlip.aspx?id=${votingCompletionForm.advocateBarId}`}
                      target="_blank"
                      className="d-block w-100"
                    >
                      Print Voting Slip
                    </a>
                  </MDBBtn>
                </div>
              ) : (
                <div className="col-md-2 mb-1">
                  <MDBBtn
                    onClick={(e) => {
                      handleVerifyVoterDetails(e);
                    }}
                  >
                    Verify Deatils
                  </MDBBtn>
                </div>
              )}
            </div> */}
          </>
        )}
      </div>
    </>
  );
};

export default Voting;
